/* 
设置部门信息

*/

import { apiMarketplace, apiSellerMarketplace } from '@/api/common'
import { apiProjectALL } from '@/api/common.js'
import { apiGetDeptTree } from '@/api/system/department'
import { apiGetAllUser } from '@/api/user'
import { Message } from '@arco-design/web-vue'

const state = () => ({
  departmentList: [],
  // 站点
  marketplace: [],
  // 店铺
  seller: [],
  // 项目
  project: [],
  // 人员（负责人）
  user: [],
})

const getters = {
  departmentList: (state) => state.departmentList,
  // 站点
  marketplace: (state) => state.marketplace,
  // 店铺
  seller: (state) => state.seller,
  // 项目
  project: (state) => state.project,
  // 人员（负责人）
  user: (state) => state.user,
}

const mutations = {
  setDepartmentList(state, departmentList) {
    state.departmentList = departmentList || []
  },
  // 站点
  marketplace(state, value) {
    state.marketplace = value || []
  },
  // 店铺
  seller(state, value) {
    state.seller = value || []
  },
  // 项目
  project(state, value) {
    state.project = value || []
  },
  // 人员（负责人）
  user(state, value) {
    state.user = value || []
  },
}

const actions = {
  async getdepartmentList({ commit }) {
    const res = await apiGetDeptTree()
    const { code, data } = res
    if (code === '200') {
      commit('setDepartmentList', data || [])
    } else {
      Message.error('获取部门失败，请联系管理员')
    }
  },
  // 站点
  async marketplace({ commit }) {
    const res = await apiMarketplace()
    if (res.code === '200') {
      commit('marketplace', res.data || [])
    } else {
      Message.error('获取站点失败，请联系管理员')
    }
  },
  // 店铺
  async seller({ commit }) {
    const res = await apiSellerMarketplace()
    if (res.code === '200') {
      commit('seller', res.data || [])
    } else {
      Message.error('获取店铺失败，请联系管理员')
    }
  },
  // 项目
  async project({ commit }) {
    const res = await apiProjectALL()
    if (res.code === '200') {
      commit('project', res.data || [])
    } else {
      Message.error('获取项目列表失败，请联系管理员')
    }
  },
  // 人员（负责人）
  async user({ commit }) {
    const res = await apiGetAllUser()
    if (res.code === '200') {
      commit('user', res.data || [])
    } else {
      Message.error('获取项目列表失败，请联系管理员')
    }
  },
}

export default { state, getters, mutations, actions }
